import React, { useEffect, useState } from "react";
import "../../assets/css/--page-blog.css";
import blogImage from "../../assets/images/blogImage.jpg";

import { Link, useParams } from "react-router-dom";
import leftSign from "../../assets/images/left.png";
import { formatBlogDate, getBlogDetails, getBlogList } from "../../helper/backend-methods";
import AppLoader from "../../components/AppLoader";
import StatusPage from "../../components/StatusPage";
import BlogCard from "./BlogCard";

export const BlogDetailsPage = () => {
  const { id } = useParams();
  const [blogDetails, setBlogDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [relatedBlogs, setRelatedBlogs] = useState([]);

  const getBlog = () => {
    getBlogDetails({ blogId: id })
      .then(({ data }) => {
        if (data.Status) {
          setBlogDetails(data.Data);
          setRelatedBlogs(data.Data?.Data?.Blogs || []);
        }
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  // const getBlogs = () => {
  //   setLoading(true);
  //   getBlogList({
  //     Category: blogDetails?.Category,
  //     PageIndex: 0,
  //     PageSize: 3,
  //     SortBy: "oldest"
  //   })
  //     .then(({ data }) => {
  //       if (data.Status) {
  //         setRelatedBlogs(data.Data?.Blogs || []);
  //         setLoading(false);
  //       }
  //     })
  //     .catch((e) => {
  //       console.error(e);
  //       setRelatedBlogs([]);
  //       setLoading(false);
  //     })
  // };

  useEffect(() => {
    getBlog();
  }, [id]);

  // useEffect(() => {
  //   if (blogDetails) {
  //     getBlogs();
  //   }
  // }, [blogDetails]);

  return loading ? (
    <div className="loader-center vh-100 blog-details-loader">
      <AppLoader />
    </div>
  ) : !blogDetails ? (
    <StatusPage status="404" />
  ) : (
    <div id="blog-details" className="blog-details-page">
      <div className="wrapper">
        <Link to={"/blogs"} className="back-to-blog">
          <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.58579 1L1.29289 6.29289C0.902369 6.68342 0.902369 7.31658 1.29289 7.70711L6.58579 13"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          Back To Blogs
        </Link>
        <div className={`blog-details-layout ${relatedBlogs.length ? "" : "pb-4"}`}>
          <div className="main-image">
            <img src={blogDetails?._blogImages[0]?.PictureUrl} alt="blog" width={1055} />
          </div>
          <div className="blog-date-and-category">
            <p className="blog-date-text">{formatBlogDate(blogDetails?.CreatedOnUtc)}</p>
            <p className="blog-date-category">
              <span className="blog-date-bullet" /> {blogDetails?.Category}
            </p>
          </div>
          <div className="blog-details-header">
            <h1>{blogDetails?.Title}</h1>
            {/* <p>{blogDetailsData.introduction}</p> */}
          </div>
          <div className="blog-details-paragraphs">
            <div dangerouslySetInnerHTML={{ __html: blogDetails?.Body }} />
            {/* {blogDetailsData.paragraphs.map((paragraph, index) => (
              <div key={index}>
                <h2>{paragraph.title}</h2>
                <p>{paragraph.description}</p>
              </div>
            ))} */}
          </div>
          {/* <div className="quote">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#C21F30" ><path d="M4.58341 17.3211C3.55316 16.2274 3 15 3 13.0103C3 9.51086 5.45651 6.37366 9.03059 4.82318L9.92328 6.20079C6.58804 8.00539 5.93618 10.346 5.67564 11.822C6.21263 11.5443 6.91558 11.4466 7.60471 11.5105C9.40908 11.6778 10.8312 13.159 10.8312 15C10.8312 16.933 9.26416 18.5 7.33116 18.5C6.2581 18.5 5.23196 18.0095 4.58341 17.3211ZM14.5834 17.3211C13.5532 16.2274 13 15 13 13.0103C13 9.51086 15.4565 6.37366 19.0306 4.82318L19.9233 6.20079C16.588 8.00539 15.9362 10.346 15.6756 11.822C16.2126 11.5443 16.9156 11.4466 17.6047 11.5105C19.4091 11.6778 20.8312 13.159 20.8312 15C20.8312 16.933 19.2642 18.5 17.3312 18.5C16.2581 18.5 15.232 18.0095 14.5834 17.3211Z"></path></svg>
                <div className="quote-content">
                <h2>{blogDetailsData.quotation}</h2>
                <p>— {blogDetailsData.author}</p>
            </div>
          </div>
          <div className="blog-details-description">
            <p>{blogDetailsData.description}</p>
          </div> */}
          <div className="blog-details-images">
            {blogDetails?._blogImages.slice(1, 3).map((image, index) => (
              <div key={index}>
                <img src={image.PictureUrl} alt={image.alt} />
              </div>
            ))}
          </div>
          <div className="separator" />
          <div className="blog-details-footer">
            <div className="tags">
              <h3>Tags :</h3>
              {blogDetails?.Tags?.map((tag, index) => (
                <span className="tag-item" key={index}>
                  <span className="hash-tag">#</span>
                  <span>{tag}</span>
                </span>
              ))}
            </div>
            <div className="share">
              <h3>Share :</h3>
              <div className="share-icons">
                <a href="#" className="social-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="#2C1E17">
                    <path d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47062 14 5.5 16 5.5H17.5V2.1401C17.1743 2.09685 15.943 2 14.6429 2C11.9284 2 10 3.65686 10 6.69971V9.5H7V13.5H10V22H14V13.5Z"></path>
                  </svg>
                </a>
                <a href="#" className="social-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="#2C1E17">
                    <path d="M6.94048 4.99993C6.94011 5.81424 6.44608 6.54702 5.69134 6.85273C4.9366 7.15845 4.07187 6.97605 3.5049 6.39155C2.93793 5.80704 2.78195 4.93715 3.1105 4.19207C3.43906 3.44699 4.18654 2.9755 5.00048 2.99993C6.08155 3.03238 6.94097 3.91837 6.94048 4.99993ZM7.00048 8.47993H3.00048V20.9999H7.00048V8.47993ZM13.3205 8.47993H9.34048V20.9999H13.2805V14.4299C13.2805 10.7699 18.0505 10.4299 18.0505 14.4299V20.9999H22.0005V13.0699C22.0005 6.89993 14.9405 7.12993 13.2805 10.1599L13.3205 8.47993Z"></path>
                  </svg>
                </a>
                <a href="#" className="social-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="#2C1E17">
                    <path d="M22.2125 5.65605C21.4491 5.99375 20.6395 6.21555 19.8106 6.31411C20.6839 5.79132 21.3374 4.9689 21.6493 4.00005C20.8287 4.48761 19.9305 4.83077 18.9938 5.01461C18.2031 4.17106 17.098 3.69303 15.9418 3.69434C13.6326 3.69434 11.7597 5.56661 11.7597 7.87683C11.7597 8.20458 11.7973 8.52242 11.8676 8.82909C8.39047 8.65404 5.31007 6.99005 3.24678 4.45941C2.87529 5.09767 2.68005 5.82318 2.68104 6.56167C2.68104 8.01259 3.4196 9.29324 4.54149 10.043C3.87737 10.022 3.22788 9.84264 2.64718 9.51973C2.64654 9.5373 2.64654 9.55487 2.64654 9.57148C2.64654 11.5984 4.08819 13.2892 6.00199 13.6731C5.6428 13.7703 5.27232 13.8194 4.90022 13.8191C4.62997 13.8191 4.36771 13.7942 4.11279 13.7453C4.64531 15.4065 6.18886 16.6159 8.0196 16.6491C6.53813 17.8118 4.70869 18.4426 2.82543 18.4399C2.49212 18.4402 2.15909 18.4205 1.82812 18.3811C3.74004 19.6102 5.96552 20.2625 8.23842 20.2601C15.9316 20.2601 20.138 13.8875 20.138 8.36111C20.138 8.1803 20.1336 7.99886 20.1256 7.81997C20.9443 7.22845 21.651 6.49567 22.2125 5.65605Z"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        {relatedBlogs.length ? (
          <div className="blog-details-related-posts">
            <h2>Related News and Articles</h2>
            <div className="related-posts blog-related-grid">
              {relatedBlogs?.map((blog, index) => (
                <BlogCard key={index} blog={blog} type="related" />
              ))}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
